"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OlapicSlider = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _olapicDataContext = require("../../contexts/olapicDataContext/olapicDataContext");
var _MediaItem = require("../MediaItem");
var _OlapicSliderButtons = require("../OlapicSliderButtons");
var _constants = require("./constants");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const OlapicSlider = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  const {
    mediaItems
  } = (0, _olapicDataContext.useOlapicData)();
  const {
    onOpenDetails,
    isOpenDetails
  } = (0, _contexts.useOlapicDetails)();
  const sliderRef = (0, _react.useRef)(null);
  const [activeItem, setActiveItem] = (0, _react.useState)(0);
  const [maxSlideRange, setMaxSlideRange] = (0, _react.useState)(0);
  const minRequiredForFive = (0, _mui.useMediaQuery)(theme.breakpoints.up('lg'));
  const totalItems = mediaItems.length;
  const isShort = totalItems <= _constants.itemsPerSet;
  const perSet = (0, _react.useMemo)(() => (0, _utils.calculatePerSet)({
    minRequiredForFive
  }), [minRequiredForFive]);
  (0, _react.useEffect)(() => {
    const sliderContainer = sliderRef.current;
    // istanbul ignore next @preserve --Not reachable in tests
    if (!sliderContainer) {
      return;
    }
    setMaxSlideRange(sliderContainer.scrollWidth);
  }, []);

  // istanbul ignore next @preserve --Not possible to test this function as OlapicSliderButtons is not visible in tests becase of styling
  const slide = (0, _react.useCallback)(direction => {
    const slideRange = minRequiredForFive ? _constants.largeSlideRange : perSet * _constants.smallSlideRange;
    const sliderContainer = sliderRef.current;
    if (!sliderContainer) {
      return;
    }
    const isLeftDirection = direction === 'left';
    const newScrollLeft = sliderContainer.scrollLeft + (isLeftDirection ? -slideRange : slideRange);
    sliderContainer.scrollLeft = newScrollLeft;
    setActiveItem(newScrollLeft);
  }, [minRequiredForFive, perSet]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      "data-testid": getTestId(_constants.WIDGET),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MediaItems, {
        ref: sliderRef,
        "data-testid": getTestId(_constants.SLIDER),
        isShort: isShort,
        scrollable: !isOpenDetails,
        dir: "ltr",
        children: [mediaItems.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MediaItem.MediaItem, {
          index: index + 1,
          item: item,
          position: (0, _utils.calculatePosition)({
            totalItems,
            index
          }),
          showDetails: onOpenDetails
        }, item.id)), isShort ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ElementsEmpty, {
          children: "\xA0"
        })]
      })
    }), isShort ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_OlapicSliderButtons.OlapicSliderButtons, {
      slide: slide,
      origin: "widget",
      activeItem: activeItem,
      maxSlideRange: maxSlideRange
    })]
  });
};
exports.OlapicSlider = OlapicSlider;
